function CollapseView({ logs }) {
  const DataCard = ({ icon, label, value, accent = "#83c14a" }) => (
    <div style={{
      background: "#fff",
      border: "1px solid #E5E7EB",
      borderRadius: "10px",
      padding: "16px",
      position: "relative",
      overflow: "hidden",
      transition: "all 0.2s ease"
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow = "none";
    }}>
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "4px",
        height: "100%",
        background: accent
      }}></div>
      <div className="d-flex align-items-start gap-3">
        <div style={{
          width: "40px",
          height: "40px",
          borderRadius: "10px",
          background: `${accent}15`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0
        }}>
          <i className={icon} style={{ fontSize: "1.125rem", color: accent }}></i>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: "0.75rem", color: "#6B7280", fontWeight: "600", marginBottom: "4px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
            {label}
          </div>
          <div style={{ fontSize: "1rem", color: "#111827", fontWeight: "700", wordBreak: "break-word" }}>
            {value || "—"}
          </div>
        </div>
      </div>
    </div>
  );

  const formattedDate = logs.created
    ? new Date(logs.created).toLocaleString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
    : "—";

  const difference = (logs?.newQuantity || 0) - (logs?.oldQuantity || 0);
  const differenceColor = difference > 0 ? "#10B981" : difference < 0 ? "#EF4444" : "#6B7280";
  const differenceIcon = difference > 0 ? "bi bi-arrow-up-circle-fill" : difference < 0 ? "bi bi-arrow-down-circle-fill" : "bi bi-dash-circle-fill";

  return (
    <div style={{
      background: "#F9FAFB",
      border: "1px solid #E5E7EB",
      borderRadius: "12px",
      padding: "20px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)"
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "20px",
        paddingBottom: "16px",
        borderBottom: "2px solid #E5E7EB"
      }}>
        <i className="bi bi-clock-history" style={{ fontSize: "1.25rem", color: "#83c14a" }}></i>
        <h6 style={{ margin: 0, fontSize: "1rem", fontWeight: "700", color: "#111827" }}>
          Inventory Log Details
        </h6>
      </div>

      <div className="row g-3">
        <div className="col-md-6">
          <DataCard 
            icon="bi bi-calendar-event"
            label="Date and Time"
            value={formattedDate}
            accent="#83c14a"
          />
        </div>

        <div className="col-md-6">
          <DataCard 
            icon="bi bi-person-circle"
            label="User"
            value={logs?.user?.email}
            accent="#3B82F6"
          />
        </div>

        <div className="col-md-6">
          <DataCard 
            icon="bi bi-sliders"
            label="Adjustment Type"
            value={logs?.adjustmentType}
            accent="#8B5CF6"
          />
        </div>

        <div className="col-md-6">
          <DataCard 
            icon="bi bi-box-seam-fill"
            label="Item Name"
            value={logs?.itemName}
            accent="#F59E0B"
          />
        </div>

        <div className="col-md-4">
          <DataCard 
            icon="bi bi-archive-fill"
            label="Old Quantity"
            value={logs?.oldQuantity}
            accent="#94A3B8"
          />
        </div>

        <div className="col-md-4">
          <DataCard 
            icon="bi bi-box-fill"
            label="New Quantity"
            value={logs?.newQuantity}
            accent="#10B981"
          />
        </div>

        <div className="col-md-4">
          <div style={{
            background: "#fff",
            border: "1px solid #E5E7EB",
            borderRadius: "10px",
            padding: "16px",
            position: "relative",
            overflow: "hidden"
          }}>
            <div style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "4px",
              height: "100%",
              background: differenceColor
            }}></div>
            <div className="d-flex align-items-start gap-3">
              <div style={{
                width: "40px",
                height: "40px",
                borderRadius: "10px",
                background: difference > 0 ? "#D1FAE5" : difference < 0 ? "#FEE2E2" : "#F3F4F6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
              }}>
                <i className={differenceIcon} style={{ fontSize: "1.125rem", color: differenceColor }}></i>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: "0.75rem", color: "#6B7280", fontWeight: "600", marginBottom: "4px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Difference
                </div>
                <div style={{ fontSize: "1rem", fontWeight: "700", color: differenceColor }}>
                  {difference > 0 ? "+" : ""}{difference}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CollapseView;
